import { memo } from 'react';
export const CustomPanel = memo(function CustomPanel(props) {
    // const {name, config, panel_key} = props;
    return null;
    // return <CustomPanelContent panel_key={panel_key} custom_content={config} />;
});
// <TabPanel title={name} panel_key={panel_key} custom>
// </TabPanel>
